import React from "react";
import { connect } from "react-redux";
import {
  set_poll_modal,
  update_emission,
  set_click_pass,
} from "../../redux/actions";
import { motion } from "framer-motion";
import t from "../../utilities/transitions";
import EmissionDetailed from "../../components/emission/EmissionDetailed";
import { MDBBtn } from "mdb-react-ui-kit";
import Spinner from "../../components/Spinner";

class EmissionsAndReplies extends React.Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    this.setState((curr) => ({
      ...curr,
      loaded: true,
    }));
  }

  /**
   * Organizes emissions into a tree
   * Root of the tree is the main emission
   * Branches are replies/replies to replies etc
   *
   *
   * @returns Tree of emissions
   */
  filterEmissions = () => {
    const emissionsWithReplies = this.props.profileInfo.emissions.items
      .filter((e) => e.replyID)
      .sort((a, b) => b.replyID - a.replyID);
    let root = [];
    emissionsWithReplies.forEach((emission) => {
      if (emission.replyEmission.replyEmission) {
        if (
          !root.find(
            (e) =>
              e.emissionID === emission.replyEmission.replyEmission.emissionID
          )
        )
          root.push({
            ...emission.replyEmission.replyEmission,
            children: [],
          });
      } else {
        if (
          !root.find((e) => e.emissionID === emission.replyEmission.emissionID)
        )
          root.push({
            ...emission.replyEmission,
            children: [],
          });
      }
    });
    root.forEach((emission, e) => {
      emissionsWithReplies.forEach((r) => {
        if (r.replyEmission.replyEmission) {
          if (
            emission.emissionID === r.replyEmission.replyEmission.emissionID
          ) {
            let found = false;
            emission.children.forEach((child, c) => {
              if (child.emissionID === r.replyEmission.emissionID) {
                found = true;
                root[e].children[c].children.push(r);
              }
            });
            if (!found)
              root[e].children.push({
                ...r.replyEmission,
                children: [r],
              });
          }
        } else if (r.replyEmission.emissionID === emission.emissionID) {
          let found = false;
          emission.children.forEach((child, c) => {
            if (child.emissionID === r.emissionID) {
              found = true;
            }
          });
          if (!found)
            root[e].children.push({
              ...r,
              children: [],
            });
        }
      });
    });
    return root;
  };

  render() {
    const {
      profileInfo,
      clickEmissionBody,
      vote,
      polls,
      submitVotes,
      pollsSubmitting,
      selectFile,
      signalBoost,
      like,
      copyEmissionLink,
      emissionCopied,
      reply,
      userInfo,
      route,
      report,
      remove,
      restore,
      seeMore,
      loadingMore,
      set_poll_modal,
      update_emission,
      handlePin,
      set_click_pass,
      clickPass,
    } = this.props;
    const { loaded } = this.state;
    const { filterEmissions } = this;
    return (
      <>
        {profileInfo.emissions.items.filter((e) => e.replyID).length ? (
          <>
            {filterEmissions().map((emission, e) => (
              <EmissionDetailed
                emission={emission}
                loaded={loaded}
                animation={t.fade_out_right}
                clickEmissionBody={clickEmissionBody}
                vote={vote}
                polls={polls}
                submitVotes={submitVotes}
                pollsSubmitting={pollsSubmitting}
                selectFile={selectFile}
                signalBoost={signalBoost}
                like={like}
                copyEmissionLink={copyEmissionLink}
                emissionCopied={emissionCopied}
                reply={reply}
                index={e}
                userInfo={userInfo}
                route={route}
                key={emission._id}
                remove={remove}
                restore={restore}
                report={report}
                profileInfo={profileInfo}
                updateEmission={update_emission}
                setPollModal={set_poll_modal}
                handlePin={handlePin}
                feedPage={true}
                setClickPass={set_click_pass}
                clickPass={clickPass}
              />
            ))}
            {profileInfo.emissions.items.filter((emission) => emission.replyID)
              .length >= profileInfo.emissions.totalReplies ? (
              <></>
            ) : (
              <div className="py-4">
                {loadingMore ? (
                  <MDBBtn
                    size="lg"
                    disabled
                    className="d-block mx-auto w-50 border-transparent"
                    rippleColor="primary"
                    outline
                    color="primary"
                    rounded
                  >
                    <Spinner color="primary" size="sm" className="me-2" />
                    Please Wait
                  </MDBBtn>
                ) : (
                  <MDBBtn
                    size="lg"
                    onClick={seeMore}
                    className="d-block mx-auto w-50"
                    rippleColor="primary"
                    outline
                    color="primary"
                    rounded
                  >
                    See More
                  </MDBBtn>
                )}
              </div>
            )}
          </>
        ) : (
          <motion.h5
            transition={t.transition}
            exit={t.fade_out_scale_1}
            animate={t.normalize}
            initial={t.fade_out}
            className="text-center display-6 mt-4"
          >
            {profileInfo?.user?._id === userInfo._id
              ? "You have "
              : `${profileInfo?.user?.displayName} has `}
            not posted any replies
          </motion.h5>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

export default connect(mapStateToProps, {
  update_emission,
  set_poll_modal,
  set_click_pass,
})(EmissionsAndReplies);
